import { createAction } from "@reduxjs/toolkit";
import {
  ChangeModuleSet,
  Language,
  Modules,
  ModuleSettingsTypes,
  ModuleType,
  PartialModuleSettings,
} from "../../types/index.js";
import { actionPrefix } from "./constants.js";

export const changeModuleStart = createAction<{
  moduleId: string;
  changeset: ChangeModuleSet;
}>(`${actionPrefix}/changeModuleStart`);

export const dragModule = createAction<{
  pageId: string;
  dragIndex: number;
  hoverIndex: number;
}>(`${actionPrefix}/dragModule`);

export const dragSubmodule = createAction<{
  parentId: string;
  moduleType: ModuleType;
  pageId: string | null;
  dragIndex: number;
  hoverIndex: number;
}>(`${actionPrefix}/dragSubmodule`);

export const moveModuleStart = createAction<{
  pageId: string | null;
  moduleId: string;
  moveBy: number;
}>(`${actionPrefix}/moveModuleStart`);

export const deleteModuleTranslationStart = createAction<{
  pageId: string | null;
  languageId: Language;
  moduleId: string;
  moduleType: ModuleType;
  parentId: string | null;
  deleteAllTranslations: boolean;
}>(`${actionPrefix}/deleteModuleTranslationStart`);

export const deleteModuleTranslationError = createAction<{
  prevState: Modules;
}>(`${actionPrefix}/deleteModuleTranslationError`);

export const setModuleSettingsStart = createAction<{
  moduleId: string;
  languageId: Language;
  settings: PartialModuleSettings<ModuleSettingsTypes>;
}>(`${actionPrefix}/setModuleSettingsStart`);
